
jQuery(document).ready(function(){

  $(document).on("click", ".custom-gorgias-chat-popup",function(){

// $(`#gorgias-chat-messenger-button`).click()
    
    // if($(`#chat-window`).hasClass('gorgias-chat-key-1pn7ot0')){
    //   $(`#chat-window`).removeClass('gorgias-chat-key-1pn7ot0').addClass('gorgias-chat-key-16g1rws');
    // } else {
    //   $(`#chat-window`).removeClass('gorgias-chat-key-16g1rws').addClass('gorgias-chat-key-1pn7ot0');
    // }
    //find iframe
    let iframe = $('#chat-button');
    let button;

    if($(window).width() > 767){
      //find button inside iframe
      button = iframe.contents().find('.messenger-button-iframe-13q50t9');
    } else {
      //find button inside iframe
      button = iframe.contents().find('.messenger-button-iframe-ps8bt3');
    }

    //trigger button click
    button.trigger("click");
  })

  // This button will increment the value
  $('.qtyplus').click(function(e){
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[id='+fieldName+']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[id='+fieldName+']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[id='+fieldName+']').val(0);
    }
  });
  // This button will decrement the value till 0
  $(".qtyminus").click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[id='+fieldName+']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 0) {
      // Decrement one
      $('input[id='+fieldName+']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[id='+fieldName+']').val(0);
    }
  });
});
$('.slide-remove-item').on('click', function(event){
  event.preventDefault();
  var productId = parseInt($(this).attr('data-id'));
  jQuery.post('/cart/update.js', 'updates['+productId+']=0')
  .done(function() {
    // console.log("success");
    window.location.reload();
  })
  .fail(function() {
    // console.log("error");
  })
  .always(function() {
    // console.log("complete");
    window.location.reload();
  });
});
Shopify.removeItem = function(variant_id, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity=0&id='+variant_id,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
        window.location.reload();

      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};
$(window).ready(function() {
  if($('.flexslider').length > 0){
    $('.flexslider').flexslider({
      animation: "slide"
    });
  }
});
function numberWithCommas(x) {
    return x.toString().split('.')[0].length > 3 ? x.toString().substring(0,x.toString().split('.')[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + x.toString().substring(x.toString().split('.')[0].length-3): x.toString();
}
/**
 * Simple custom cart drawer
 * - Uses /cart.js and /cart/add.js
 * - No Rebuy or theme app dependencies
 */
(function() {
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || "${{amount}}";
    var parts = (cents / 100).toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var value = parts.join(".");
    return format.replace("{{amount}}", value).replace("{{ amount }}", value);
  }

  function updateHeaderCart(cart) {
    var count = typeof cart.item_count === "number" ? cart.item_count : 0;
    var countEl = document.getElementById("custom-cart-count");
    if (countEl) countEl.textContent = count;
    var countElDesktop = document.getElementById("custom-cart-count-desktop");
    if (countElDesktop) countElDesktop.textContent = count;
    var priceEl = document.querySelector("#cart-price-wrap, .site-header__cart .price_text");
    if (priceEl) {
      priceEl.textContent = formatMoney(cart.total_price);
    }

    var drawerTitleEl = document.getElementById("custom-cart-drawer-title");
    if (drawerTitleEl) {
      if (cart.item_count > 0) {
        drawerTitleEl.textContent = "Cart(" + cart.item_count + ")";
      } else {
        drawerTitleEl.textContent = "Cart";
      }
    }
  }

  function renderCartDrawer(cart) {
    var container = document.getElementById("custom-cart-drawer-body");
    if (!container) return;

    if (!cart.items || !cart.items.length) {
      var emptyTemplate = document.getElementById("custom-cart-empty-template");
      if (emptyTemplate) {
        container.innerHTML = emptyTemplate.innerHTML;
      } else {
        container.innerHTML = '<div class="custom-cart-empty">Your cart is empty.</div>';
      }
      return;
    }

    var itemsHtml = cart.items.map(function(item, index) {
      var imageHtml = "";
      if (item.image) {
        imageHtml = '<img src="' + item.image + '" alt="' + (item.product_title || "") + '">';
      }

      var propertiesHtml = "";
      if (item.properties && Object.keys(item.properties).length) {
        propertiesHtml =
          '<ul class="custom-cart-item-properties">' +
          Object.keys(item.properties)
            .map(function(key) {
              var value = item.properties[key];
              if (value === null || value === "") return "";
              return (
                '<li class="custom-cart-item-property">' +
                  '<span class="custom-cart-item-property-name">' + key + ":</span> " +
                  '<span class="custom-cart-item-property-value">' + value + "</span>" +
                "</li>"
              );
            })
            .join("") +
          "</ul>";
      }

      var hasComparePrice =
        typeof item.original_line_price === "number" &&
        item.original_line_price > item.line_price;

      var priceHtml;
      if (hasComparePrice) {
        priceHtml =
          '<div class="custom-cart-item-price">' +
            '<span class="custom-cart-item-price-original">' + formatMoney(item.original_line_price) + "</span>" +
            '<span class="custom-cart-item-price-current">' + formatMoney(item.line_price) + "</span>" +
          "</div>";
      } else {
        priceHtml =
          '<div class="custom-cart-item-price">' +
            '<span>' + formatMoney(item.line_price) + "</span>" +
          "</div>";
      }

      return '' +
        '<div class="custom-cart-item" data-line="' + (index + 1) + '" data-qty="' + item.quantity + '">' +
          '<div class="custom-cart-item-image">' +
            '<a href="' + item.url + '">' + imageHtml + "</a>" +
          "</div>" +
          '<div class="custom-cart-item-content">' +
          '<div class="custom-cart-item-content-top">' +
          '<div class="custom-cart-item-title-row">' +
          '<a class="custom-cart-item-title" href="' + item.url + '">' + item.product_title + "</a>" +
          '<button type="button" class="custom-cart-item-remove" data-cart-action="remove" aria-label="Remove item"><svg class="custom-cart-item-remove-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none"><path d="M11.8125 2.1875C11.9401 2.1875 12.0449 2.22852 12.127 2.31055C12.209 2.39258 12.25 2.4974 12.25 2.625V3.0625C12.25 3.1901 12.209 3.29492 12.127 3.37695C12.0449 3.45898 11.9401 3.5 11.8125 3.5H11.375L10.8008 12.7695C10.7826 13.1159 10.6458 13.4076 10.3906 13.6445C10.1354 13.8815 9.83464 14 9.48828 14H2.76172C2.41536 14 2.11458 13.8815 1.85938 13.6445C1.60417 13.4076 1.46745 13.1159 1.44922 12.7695L0.875 3.5H0.4375C0.309896 3.5 0.205078 3.45898 0.123047 3.37695C0.0410156 3.29492 0 3.1901 0 3.0625V2.625C0 2.4974 0.0410156 2.39258 0.123047 2.31055C0.205078 2.22852 0.309896 2.1875 0.4375 2.1875H2.67969L3.60938 0.628906C3.86458 0.209636 4.2474 0 4.75781 0H7.49219C8.0026 0 8.38542 0.209636 8.64062 0.628906L9.57031 2.1875H11.8125ZM4.75781 1.3125L4.21094 2.1875H8.03906L7.49219 1.3125H4.75781ZM9.48828 12.6875L10.0625 3.5H2.1875L2.76172 12.6875H9.48828Z" fill="#999999"/></svg></button>' +
          "</div>" +
              (item.variant_title ? '<div class="custom-cart-item-variant">' + item.variant_title + "</div>" : "") +
              propertiesHtml +
              (item.sku ? '<div class="custom-cart-item-sku">SKU: ' + item.sku + "</div>" : "") +
            "</div>" +
            '<div class="custom-cart-item-content-bottom">' +
              priceHtml +
              '<div class="custom-cart-item-qty">' +
                '<button type="button" class="custom-cart-item-qty-btn custom-cart-item-qty-decrease" data-cart-action="decrease" aria-label="Decrease quantity"><svg class="custom-cart-item-qty-icon custom-cart-item-qty-icon-decrease" xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none"><path d="M8.625 5.75C8.73438 5.75 8.82422 5.78516 8.89453 5.85547C8.96484 5.92578 9 6.01562 9 6.125V6.875C9 6.98438 8.96484 7.07422 8.89453 7.14453C8.82422 7.21484 8.73438 7.25 8.625 7.25H0.375C0.265625 7.25 0.175781 7.21484 0.105469 7.14453C0.0351562 7.07422 0 6.98438 0 6.875V6.125C0 6.01562 0.0351562 5.92578 0.105469 5.85547C0.175781 5.78516 0.265625 5.75 0.375 5.75H8.625Z" fill="#232323"/></svg></button>' +
                '<input type="number" class="custom-cart-item-qty-value" name="updates[]" value="' + item.quantity + '" min="1" step="1" aria-label="Quantity" inputmode="numeric" pattern="[0-9]*" autocomplete="off" data-qty-input>' +
                '<button type="button" class="custom-cart-item-qty-btn custom-cart-item-qty-increase" data-cart-action="increase" aria-label="Increase quantity"><svg class="custom-cart-item-qty-icon custom-cart-item-qty-icon-increase" xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none"><path d="M8.625 5.75C8.73438 5.75 8.82422 5.78516 8.89453 5.85547C8.96484 5.92578 9 6.01562 9 6.125V6.875C9 6.98438 8.96484 7.07422 8.89453 7.14453C8.82422 7.21484 8.73438 7.25 8.625 7.25H5.25V10.625C5.25 10.7344 5.21484 10.8242 5.14453 10.8945C5.07422 10.9648 4.98438 11 4.875 11H4.125C4.01562 11 3.92578 10.9648 3.85547 10.8945C3.78516 10.8242 3.75 10.7344 3.75 10.625V7.25H0.375C0.265625 7.25 0.175781 7.21484 0.105469 7.14453C0.0351562 7.07422 0 6.98438 0 6.875V6.125C0 6.01562 0.0351562 5.92578 0.105469 5.85547C0.175781 5.78516 0.265625 5.75 0.375 5.75H3.75V2.375C3.75 2.26562 3.78516 2.17578 3.85547 2.10547C3.92578 2.03516 4.01562 2 4.125 2H4.875C4.98438 2 5.07422 2.03516 5.14453 2.10547C5.21484 2.17578 5.25 2.26562 5.25 2.375V5.75H8.625Z" fill="#232323"/></svg></button>' +
              "</div>" +
            "</div>" +
          "</div>" +
        "</div>";
    }).join("");

    // Placeholder for cart recommendations (populated asynchronously)
    var recommendationsContainerHtml =
      '<div id="custom-cart-recommendations" class="custom-cart-recommendations"></div>';

    var footerHtml =
      '<div class="custom-cart-footer">' +
        '<div class="custom-cart-subtotal">' +
          "<span class='custom-cart-subtotal-left'>Subtotal: " + cart.item_count + ' items</span>' +
          "<span class='custom-cart-subtotal-right'>" + formatMoney(cart.total_price) + "</span>" +
        "</div>" +
        '<div class="custom-cart-shipping-note">' +
          "<span class='custom-cart-shipping-note-left'>Shipping</span>" +
          "<span class='custom-cart-shipping-note-right'>FREE</span>" +
        "</div>" +
        '<div class="custom-cart-actions">' +
          '<a href="/checkout" class="custom-cart-checkout">Checkout</a>' +
        "</div>" +
      "</div>";

    container.innerHTML =
      '<div class="custom-cart-drawer-inner">' +
        '<div class="custom-cart-drawer-scroll">' +
          '<div class="custom-cart-item-wrapper">' +
            itemsHtml +
          "</div>" +
          recommendationsContainerHtml +
        "</div>" +
        footerHtml +
      "</div>";
  }

  function loadCartRecommendations(cart) {
    if (!cart || !cart.items || !cart.items.length) return;

    var recContainer = document.getElementById("custom-cart-recommendations");
    if (!recContainer) return;

    var shopDomain = 'gtglass.myshopify.com';

    // Collect all unique product IDs currently in the cart
    var cartProductIds = [];
    cart.items.forEach(function(item) {
      if (item && item.product_id) {
        var id = String(item.product_id);
        if (cartProductIds.indexOf(id) === -1) cartProductIds.push(id);
      }
    });
    if (!cartProductIds.length) return;

    function fetchFBT(productId) {
      var apiUrl = 'https://cdn.codeblackbelt.com/public/api/v1/frequently-bought-together?productId=' +
        encodeURIComponent(productId) + '&shop=' + encodeURIComponent(shopDomain);
      return fetch(apiUrl, { credentials: 'omit', headers: { Accept: 'application/json' } })
        .then(function(res) { return res.ok ? res.json() : []; })
        .then(function(payload) {
          return Array.isArray(payload) ? payload
            : Array.isArray(payload && payload.recommendations) ? payload.recommendations
            : Array.isArray(payload && payload.products) ? payload.products
            : Array.isArray(payload && payload.items) ? payload.items
            : Array.isArray(payload && payload.data) ? payload.data
            : [];
        })
        .catch(function() { return []; });
    }

    function extractHandle(item) {
      if (!item) return null;
      var src = item.product || item.product_data || item.productData || item;
      return src.handle || src.product_handle || src.productHandle || item.handle || null;
    }

    function fetchProductByHandle(handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function(res) { return res.ok ? res.json() : null; })
        .catch(function() { return null; });
    }

    Promise.all(cartProductIds.map(fetchFBT))
      .then(function(allRawResults) {
        var seenHandles = {};
        var handlesToFetch = [];
        allRawResults.forEach(function(rawProducts) {
          rawProducts.forEach(function(item) {
            var handle = extractHandle(item);
            if (!handle || seenHandles[handle]) return;
            seenHandles[handle] = true;
            handlesToFetch.push(handle);
          });
        });
        if (!handlesToFetch.length) { recContainer.innerHTML = ''; return; }
        return Promise.all(handlesToFetch.map(fetchProductByHandle));
      })
      .then(function(products) {
        if (!products) return;

        var seenIds = {};
        var filtered = products.filter(function(product) {
          if (!product || !product.id || !product.variants || !product.variants.length) return false;
          var id = String(product.id);
          if (seenIds[id] || cartProductIds.indexOf(id) !== -1) return false;
          seenIds[id] = true;
          return true;
        });

        if (!filtered.length) {
          recContainer.innerHTML = "";
          return;
        }

        var productsHtml = filtered.map(function(product) {
          if (!product || !product.variants || !product.variants.length) {
            return "";
          }

          var firstVariant = product.variants[0];
          var imageSrc = "";
          if (product.featured_image) {
            imageSrc =
              product.featured_image.src ||
              product.featured_image.url ||
              product.featured_image;
          } else if (product.images && product.images.length) {
            imageSrc =
              product.images[0].src ||
              product.images[0].url ||
              product.images[0];
          }

          var imageHtml = imageSrc
            ? '<img src="' + imageSrc + '" alt="' + (product.title || "") + '">'
            : "";

          var priceHtml = "";
          if (typeof firstVariant.price === "number") {
            priceHtml = formatMoney(firstVariant.price);
          } else if (typeof firstVariant.price === "string") {
            // price sometimes comes as cents in string
            var cents = parseInt(firstVariant.price, 10);
            if (!isNaN(cents)) {
              priceHtml = formatMoney(cents);
            }
          }

          // Judge.me review count: metafield judgeme.review_widget_data (object with number_of_reviews)
          var reviewCount = 0;
          var widgetData = product.metafields && product.metafields.judgeme && product.metafields.judgeme.review_widget_data;
          console.log("widgetData: ", widgetData);
          if (widgetData) {
            var val = widgetData.value !== undefined ? widgetData.value : widgetData;
            if (typeof val === "object" && val !== null && typeof val.number_of_reviews === "number") {
              reviewCount = val.number_of_reviews;
            } else if (typeof val === "string") {
              try {
                var parsed = JSON.parse(val);
                if (parsed && typeof parsed.number_of_reviews === "number") {
                  reviewCount = parsed.number_of_reviews;
                }
              } catch (e) {}
            }
          }
          var starSvg =
            '<svg class="custom-cart-recommendations-item-reviews-star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
              '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.19212 2.14054C7.49101 1.4219 8.50903 1.4219 8.80793 2.14054L10.1959 5.47768L13.7986 5.76651C14.5745 5.8287 14.8891 6.7969 14.298 7.30323L11.5531 9.65453L12.3917 13.1702C12.5723 13.9272 11.7487 14.5256 11.0845 14.1199L8.00002 12.236L4.91559 14.1199C4.25137 14.5256 3.42778 13.9272 3.60837 13.1702L4.44698 9.65453L1.70208 7.30323C1.11099 6.7969 1.42557 5.8287 2.20139 5.76651L5.80412 5.47768L7.19212 2.14054Z" fill="#FFB800"/>' +
            "</svg>";
          var reviewsHtml =
            '<div class="custom-cart-recommendations-item-reviews" data-product-id="' + product.id + '">' +
              '<span class="custom-cart-recommendations-item-reviews-star-wrap">' + starSvg + "</span>" +
              '<span class="custom-cart-recommendations-item-reviews-count">' + reviewCount + " review" + (reviewCount === 1 ? "" : "s") + "</span>" +
            "</div>";

          var atcBtnHtml =
            '<button type="button" class="custom-cart-recommendations-atc" data-variant-id="' + firstVariant.id + '">' +
              '<span class="custom-cart-recommendations-atc-icon">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 2.25V9.75M9.75 6L2.25 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              "</span>" +
              '<span class="custom-cart-recommendations-atc-text">Add</span>' +
            "</button>";

          var productUrl = product.url || ('/products/' + product.handle);

          var topRowHtml =
            '<div class="custom-cart-recommendations-item-top">' +
              '<a class="custom-cart-recommendations-item-title" href="' + productUrl + '">' +
                product.title +
              "</a>" +
            "</div>";

          var bottomRowHtml =
            '<div class="custom-cart-recommendations-item-bottom">' +
              (priceHtml
                ? '<span class="custom-cart-recommendations-item-price">' + priceHtml + "</span>"
                : "") +
              atcBtnHtml +
            "</div>";

          return '' +
            '<div class="custom-cart-recommendations-item" data-product-id="' + product.id + '">' +
              '<a href="' + productUrl + '" class="custom-cart-recommendations-item-image">' +
                imageHtml +
              "</a>" +
              '<div class="custom-cart-recommendations-item-content">' +
                topRowHtml +
                bottomRowHtml +
              "</div>" +
            "</div>";
        }).join("");

        if (!productsHtml) {
          recContainer.innerHTML = "";
          return;
        }

        recContainer.innerHTML =
          '<div class="custom-cart-recommendations-inner">' +
          '<button type="button" class="custom-cart-recommendations-toggle" aria-expanded="true">' +
              '<span class="custom-cart-recommendations-heading">Recommended for you</span>' +
              '<span class="custom-cart-recommendations-toggle-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.26517 8.14017C6.11872 8.28661 5.88128 8.28661 5.73484 8.14017L1.98483 4.39017C1.83839 4.24372 1.83839 4.00628 1.98483 3.85984C2.13128 3.71339 2.36872 3.71339 2.51517 3.85984L6 7.34467L9.48484 3.85984C9.63128 3.71339 9.86872 3.71339 10.0152 3.85984C10.1616 4.00628 10.1616 4.24372 10.0152 4.39017L6.26517 8.14017Z" fill="black" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
            "</button>" +
            '<div class="custom-cart-recommendations-body is-open">' +
              '<div class="custom-cart-recommendations-scroll-wrapper">' +
                '<div class="custom-cart-recommendations-list">' +
                  productsHtml +
                "</div>" +
              "</div>" +
              '<div class="custom-cart-recommendations-arrows">' +
                '<button type="button" class="custom-cart-recommendations-arrow custom-cart-recommendations-arrow-prev" data-direction="prev" aria-label="Previous recommended products"><svg class="custom-cart-recommendations-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M2 2L8 8L2 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
                '<button type="button" class="custom-cart-recommendations-arrow custom-cart-recommendations-arrow-next" data-direction="next" aria-label="Next recommended products"><svg class="custom-cart-recommendations-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M2 2L8 8L2 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
              "</div>" +
              '<div class="custom-cart-recommendations-dots"></div>' +
            "</div>" +
          "</div>";

        // Toggle accordion open/close
        var toggleButton = recContainer.querySelector(".custom-cart-recommendations-toggle");
        var bodyEl = recContainer.querySelector(".custom-cart-recommendations-body");
        if (toggleButton && bodyEl) {
          toggleButton.addEventListener("click", function() {
            var isOpen = bodyEl.classList.toggle("is-open");
            toggleButton.setAttribute("aria-expanded", isOpen ? "true" : "false");
          });
        }

        // Horizontal scroll with arrows
        var scrollWrapper = recContainer.querySelector(".custom-cart-recommendations-scroll-wrapper");
        var listEl = recContainer.querySelector(".custom-cart-recommendations-list");
        var items = listEl ? listEl.querySelectorAll(".custom-cart-recommendations-item") : [];
        var prevArrow = recContainer.querySelector(".custom-cart-recommendations-arrow-prev");
        var nextArrow = recContainer.querySelector(".custom-cart-recommendations-arrow-next");
        var dotsContainer = recContainer.querySelector(".custom-cart-recommendations-dots");
        var currentIndex = 0;

        function getScrollAmount() {
          if (!items || !items.length) return 0;
          var firstItem = items[0];
          return firstItem.offsetWidth || 0;
        }

        var inactiveDotSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none"><circle cx="3" cy="3" r="2.5" stroke="black" stroke-width="0.5"/></svg>';
        var activeDotSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none"><circle cx="3" cy="3" r="2.5" fill="black"/></svg>';

        function updateActiveDot() {
          if (!dotsContainer) return;
          var dots = dotsContainer.querySelectorAll(".custom-cart-recommendations-dot");
          if (!dots.length) return;
          dots.forEach(function(dot, index) {
            if (index === currentIndex) {
              dot.classList.add("is-active");
              dot.setAttribute("aria-current", "true");
            } else {
              dot.classList.remove("is-active");
              dot.removeAttribute("aria-current");
            }
          });
        }

        function scrollToIndex(index) {
          if (!scrollWrapper) return;
          var amount = getScrollAmount();
          if (!amount) {
            amount = scrollWrapper.offsetWidth || 0;
          }
          var maxIndex = items.length ? items.length - 1 : 0;
          if (index < 0) index = 0;
          if (index > maxIndex) index = maxIndex;
          currentIndex = index;
          scrollWrapper.scrollTo({
            left: index * amount,
            behavior: "smooth"
          });
          updateActiveDot();
        }

        function scrollByDirection(direction) {
          scrollToIndex(currentIndex + direction);
        }

        function updateIndexFromScroll() {
          if (!scrollWrapper) return;
          var amount = getScrollAmount();
          if (!amount) return;
          var newIndex = Math.round(scrollWrapper.scrollLeft / amount);
          if (newIndex !== currentIndex) {
            currentIndex = newIndex;
            updateActiveDot();
          }
        }

        function buildDots() {
          if (!dotsContainer || !items.length) return;
          dotsContainer.innerHTML = "";
          Array.prototype.forEach.call(items, function(_, index) {
            var dotEl = document.createElement("span");
            dotEl.className = "custom-cart-recommendations-dot";
            dotEl.setAttribute("data-index", String(index));
            dotEl.setAttribute("role", "button");
            dotEl.setAttribute("tabindex", "0");
            dotEl.setAttribute("aria-label", "Go to recommended product " + (index + 1));
            dotEl.addEventListener("click", function() {
              scrollToIndex(index);
            });
            dotsContainer.appendChild(dotEl);
          });
          currentIndex = 0;
          updateActiveDot();
        }

        if (prevArrow) {
          prevArrow.addEventListener("click", function() {
            scrollByDirection(-1);
          });
        }
        if (nextArrow) {
          nextArrow.addEventListener("click", function() {
            scrollByDirection(1);
          });
        }

        if (scrollWrapper) {
          scrollWrapper.addEventListener("scroll", function() {
            updateIndexFromScroll();
          });
        }

        // Initialize dots (primarily for mobile; control visibility via CSS)
        buildDots();

        // Add-to-cart for recommendation items
        recContainer.addEventListener("click", function(evt) {
          var atcButton = evt.target.closest(".custom-cart-recommendations-atc");
          if (!atcButton) return;

          evt.preventDefault();
          var variantId = atcButton.getAttribute("data-variant-id");
          if (!variantId) return;

          var body = "id=" + encodeURIComponent(variantId) + "&quantity=1";
          fetch("/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
              "Accept": "application/json"
            },
            body: body
          })
            .then(function(res) {
              if (!res.ok) {
                return res.json().then(function(err) { throw err; });
              }
              return res.json();
            })
            .then(function() {
              refreshCartDrawer({ open: true });
            })
            .catch(function() {
              alert("Unable to add this item to cart. Please try again.");
            });
        });
      })
      .catch(function() {
        // Fail silently for recommendations
      });
  }

  function updateCartShippingMessage(cart) {
    var textEl = document.getElementById("custom-cart-drawer-shipping-text");
    var barEl = document.getElementById("custom-cart-drawer-progress-fill");
    if (!textEl && !barEl) return;
    var total = cart.total_price / 100;
    var threshold = 100;

    var itemCount = (cart && typeof cart.item_count === "number") ? cart.item_count : 0;

    if (itemCount === 0) {
      if (textEl) {
        textEl.textContent = "Free Standard Delivery for orders over $100";
      }
      if (barEl) {
        barEl.style.width = "0%";
      }
    } else if (total < threshold) {
      var remaining = threshold - total;
      var remainingFormatted = numberWithCommas(remaining.toFixed(2));
      if (textEl) {
        textEl.textContent = "Spend $" + remainingFormatted + " more to earn free shipping";
      }
      if (barEl) {
        var percent = Math.min(100, (total / threshold) * 100);
        barEl.style.width = percent + "%";
      }
    } else {
      if (textEl) {
        textEl.innerHTML =
          '<span class="custom-cart-drawer__shipping-icon" aria-hidden="true">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M1.125 6C1.125 3.30761 3.30761 1.125 6 1.125C8.69239 1.125 10.875 3.30761 10.875 6C10.875 8.69239 8.69239 10.875 6 10.875C3.30761 10.875 1.125 8.69239 1.125 6ZM7.80515 5.09296C7.92553 4.92443 7.88649 4.69023 7.71796 4.56985C7.54943 4.44947 7.31523 4.48851 7.19485 4.65704L5.57715 6.92182L4.76516 6.10984C4.61872 5.96339 4.38128 5.96339 4.23484 6.10984C4.08839 6.25628 4.08839 6.49372 4.23484 6.64016L5.35984 7.76517C5.43778 7.84311 5.54607 7.88281 5.65593 7.87372C5.76579 7.86463 5.86608 7.80766 5.93015 7.71796L7.80515 5.09296Z" fill="#15803D"/>' +
          "</svg>" +
          "</span>" +
          '<span class="custom-cart-drawer__shipping-message">You have earned free shipping</span>';
      }
      if (barEl) {
        barEl.style.width = "100%";
      }
    }
  }

  function openCartDrawer() {
    var drawer = document.getElementById("custom-cart-drawer");
    if (drawer) {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
    }
    if (document && document.body) {
      document.body.classList.add("custom-cart-open");
    }
  }

  /** Refresh only header cart count and drawer title (no full drawer refresh). Call after add-to-cart from anywhere. */
  function refreshCartCount() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function(res) { return res.json(); })
      .then(updateHeaderCart)
      .catch(function() {});
  }

  /** Global API for custom cart drawer: open, refresh (full), refreshCount (header only). */
  window.CustomCartDrawer = {
    open: openCartDrawer,
    close: closeCartDrawer,
    refresh: function(opts) {
      refreshCartDrawer(opts || {});
    },
    refreshCount: refreshCartCount
  };

  function closeCartDrawer() {
    var drawer = document.getElementById("custom-cart-drawer");
    if (drawer) {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
    }
    if (document && document.body) {
      document.body.classList.remove("custom-cart-open");
    }
  }

  function refreshCartDrawer(options) {
    options = options || {};
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        renderCartDrawer(cart);
        updateHeaderCart(cart);
        updateCartShippingMessage(cart);
        loadCartRecommendations(cart);
        if (options.open) {
          openCartDrawer();
        }
      })
      .catch(function() {
        // fail silently
      });
  }

  function updateCartLine(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Accept": "application/json"
      },
      body: "line=" + encodeURIComponent(line) + "&quantity=" + encodeURIComponent(quantity)
    })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        renderCartDrawer(cart);
        updateHeaderCart(cart);
        updateCartShippingMessage(cart);
        loadCartRecommendations(cart);
      })
      .catch(function() {
        alert("Unable to update cart. Please try again.");
      });
  }

  document.addEventListener("DOMContentLoaded", function() {
    // Initial render so drawer is ready
    refreshCartDrawer();

    // Open drawer and add to cart via AJAX on product forms (capture phase so we run before other scripts)
    document.body.addEventListener("submit", function(evt) {
      var form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = (form.getAttribute("action") || "").trim();
      if (action.indexOf("/cart/add") === -1) return;

      evt.preventDefault();
      evt.stopPropagation();

      var formData = new FormData(form);
      fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json" },
        body: formData
      })
        .then(function(res) {
          if (!res.ok) {
            return res.json().then(function(err) { throw err; });
          }
          return res.json();
        })
        .then(function() {
          refreshCartDrawer({ open: true });
          // Ensure drawer stays open (re-apply in case of timing/other scripts)
          setTimeout(openCartDrawer, 150);
        })
        .catch(function(err) {
          var message = (err && err.description) || "Unable to add to cart. Please try again.";
          alert(message);
        });
    }, true);

    // Ensure header cart icon opens drawer with fresh data
    var headerCartTriggers = document.querySelectorAll(
      'a[href="#custom-cart-drawer"], .site-header__cart, button[data-cart-drawer-toggle]'
    );
    headerCartTriggers.forEach(function(trigger) {
      trigger.addEventListener("click", function(evt) {
        evt.preventDefault();
        refreshCartDrawer({ open: true });
      });
    });

    // Close button inside drawer
    var cartDrawer = document.getElementById("custom-cart-drawer");
    if (cartDrawer) {
      cartDrawer.addEventListener("click", function(evt) {
        if (evt.target.closest("[data-custom-cart-close]")) {
          evt.preventDefault();
          closeCartDrawer();
        }
      });
    }

    // Quantity / remove controls inside drawer (event delegation)
    var cartContainer = document.getElementById("custom-cart-drawer-body");
    if (cartContainer) {
      cartContainer.addEventListener("click", function(evt) {
        var actionButton = evt.target.closest("[data-cart-action]");
        if (!actionButton) return;

        evt.preventDefault();
        var action = actionButton.getAttribute("data-cart-action");
        var itemRow = actionButton.closest("[data-line]");
        if (!itemRow) return;

        var line = parseInt(itemRow.getAttribute("data-line"), 10);
        var qtyInput = itemRow.querySelector("[data-qty-input]");
        var currentQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : (parseInt(itemRow.getAttribute("data-qty"), 10) || 1);
        var newQty = currentQty;

        if (action === "increase") {
          newQty = currentQty + 1;
        } else if (action === "decrease") {
          newQty = Math.max(0, currentQty - 1);
        } else if (action === "remove") {
          newQty = 0;
        }

        updateCartLine(line, newQty);
      });

      cartContainer.addEventListener("change", function(evt) {
        var input = evt.target.closest("[data-qty-input]");
        if (!input) return;
        var itemRow = input.closest("[data-line]");
        if (!itemRow) return;
        var line = parseInt(itemRow.getAttribute("data-line"), 10);
        var newQty = parseInt(input.value, 10);
        if (isNaN(newQty) || newQty < 1) {
          input.value = parseInt(itemRow.getAttribute("data-qty"), 10) || 1;
          return;
        }
        updateCartLine(line, newQty);
      });
    }
  });
})();

(function () {
  var observer;
  var debounceTimer;
  // keyed by product handle → Promise<number|null>
  // Storing the Promise (not the resolved value) means every caller chains
  // .then() on the same Promise — no duplicate network requests, and cache
  // hits resolve as microtasks (before any Snize re-render macrotask).
  var ratingCache = {};

  var starSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.19212 2.14054C7.49101 1.4219 8.50903 1.4219 8.80793 2.14054L10.1959 5.47768L13.7986 5.76651C14.5745 5.8287 14.8891 6.7969 14.298 7.30323L11.5531 9.65453L12.3917 13.1702C12.5723 13.9272 11.7487 14.5256 11.0845 14.1199L8.00002 12.236L4.91559 14.1199C4.25137 14.5256 3.42778 13.9272 3.60837 13.1702L4.44698 9.65453L1.70208 7.30323C1.11099 6.7969 1.42557 5.8287 2.20139 5.76651L5.80412 5.47768L7.19212 2.14054Z" fill="#FFB800"/>' +
    '</svg>';

  // Extract handle from the first /products/ link inside the card
  function getHandle(li) {
    var link = li.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  function fetchRating(handle) {
    if (handle in ratingCache) return ratingCache[handle];
    ratingCache[handle] = fetch('/products/' + handle + '?view=search-page-metafields', { credentials: 'same-origin' })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var rating = 4.9;
        if (data && typeof data.rating === 'number' && data.rating > 0) {
          rating = data.rating;
        } else if (data && data.review_widget_data) {
          var wd = data.review_widget_data;
          if (typeof wd === 'string') {
            try { wd = JSON.parse(wd); } catch (e) { wd = null; }
          }
          if (wd && wd.average_rating) {
            var parsed = parseFloat(wd.average_rating);
            if (!isNaN(parsed) && parsed > 0) rating = parsed;
          }
        }
        runLogic();
        return rating;
      })
      .catch(function() { return 4.9; });
    return ratingCache[handle];
  }

  function injectRatings() {
    var items = document.querySelectorAll(
      '#snize_results .snize-search-results-content > li[data-original-product-id]'
    );
    if (!items.length) return;

    items.forEach(function(li) {
      var handle = getHandle(li);
      if (!handle) return;

      var thumbnailWrapper = li.querySelector('.snize-thumbnail-wrapper');
      if (!thumbnailWrapper) return;
      if (thumbnailWrapper.querySelector('.custom-collection-product__rating')) return;

      fetchRating(handle).then(function(rating) {
        var currentWrapper = li.querySelector('.snize-thumbnail-wrapper');
        if (!currentWrapper) return;
        if (currentWrapper.querySelector('.custom-collection-product__rating')) return;
        var ratingEl = document.createElement('div');
        ratingEl.className = 'custom-collection-product__rating';
        ratingEl.innerHTML =
          '<div class="custom-collection-product__star">' + starSvg + '</div>' +
          '<span class="custom-collection__rating-value">' + rating.toFixed(1) + '</span>';
        currentWrapper.appendChild(ratingEl);
      });
    });
  }

  function runLogic() {
    var prices = document.querySelectorAll('#snize_results .snize-search-results-content > li .snize-price-list');

    prices.forEach(function(priceEl) {
      var originalPriceEl = priceEl.querySelector(".snize-price");
      var discountedPriceEl = priceEl.querySelector(".snize-discounted-price.money");

      if (originalPriceEl && discountedPriceEl) {
        var originalPrice = parseFloat(originalPriceEl.textContent.replace(/[^0-9.]/g, ''));
        var discountedPrice = parseFloat(discountedPriceEl.textContent.replace(/[^0-9.]/g, ''));

        if (originalPrice && discountedPrice) {
          var percentOff = Math.round(((discountedPrice - originalPrice) / discountedPrice) * 100);
          var parentLi = priceEl.closest("li");
          if (!parentLi) return;
          var thumbnailWrapper = parentLi.querySelector(".snize-thumbnail-wrapper");
          if (!thumbnailWrapper) return;
          if (!thumbnailWrapper.querySelector(".custom-discount-badge")) {
            var badge = document.createElement("span");
            badge.className = "custom-discount-badge";
            badge.textContent = percentOff + "% OFF";
            thumbnailWrapper.appendChild(badge);
          }
        }
      }
    });

    injectRatings();
  }

  function startObserver() {
    observer = new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(runLogic, 100);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  startObserver();
})();
